import { alpha, darken, lighten } from "@mui/system";

const styles = (theme) => ({
	paper: {
		p: 2,
		mb: 2,
	},
	autocompleteServicos: {
		width: 300,
		mt: 2,
	},
	pagination: {
		marginTop: "auto",
		display: "flex",
		justifyContent: "center",
		mt: 2,
	},
	containerTextNoTicketsError: {
		position: "absolute",
		left: "45%",
		top: "45%",
		transform: "translateX(-50%)",
		"@media (max-width: 700px)": {
			left: "38%",
		},
		"@media (max-width: 600px)": {
			left: "40%",
			top: "20%",
		},
		"@media (max-width: 430px)": {
			left: "38%",
			top: "18%",
		},
	},
	containerNoTickets: {
		width: "100%",
		height: "100%",

		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		pt: 2,
	},
	paperFluxo: {
		borderRadius: "16px",
		flex: 1,
		height: "100%",
		overflowY: "auto",
		position: "relative",
		p: 1,
	},
	headStcker: {
		display: "flex",
		flexDirection: "column",
		// Remova position, background, backdropFilter daqui
		width: "100%", // Garante que ocupe a largura
	},

	containerServiceItem: {
		display: "flex",
		flexDirection: "column",
		position: "relative",
	},

	boxButtons: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		gap: 1,
		flexDirection: "row",
		width: "100%",
		// Remova position, background, backdropFilter daqui também
	},
	boxCampos: {
		display: "flex",
		gap: 1,
	},
	icons: {
		fontSize: 18,
		color: theme.palette.primary.main,
	},
	typhographyTitle: {
		fontWeight: "bold",
		fontSize: 14,
	},
	typographyLabel: {
		fontSize: 14,
		cursor: "pointer",
	},
	boxEmpty: {
		height: "100%",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		flexDirection: "column",
	},
	boxHeader: {
		position: "sticky",
		top: -16,
		zIndex: 2,
		backgroundColor: alpha(theme.palette.background.paper, 0.85),
		backdropFilter: "blur(3px)",
		borderBottom: "1px solid",
		borderColor: "divider",
		mx: -2,
		mt: -2,
		px: 2,
		py: 2,
		mb: 3,
	},

	//CARDSELECTION

	icons: {
		width: 35,
		height: 35,
		borderRadius: "50%",
		backgroundColor:
			theme.palette.mode === "dark"
				? lighten(theme.palette.background.paper, 0.2)
				: darken(theme.palette.background.paper, 0.1),
	},
	actionButtonDelete: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		height: "100%",
		width: "100%",
		transition: "background-color 0.2s",
		"&:hover": {
			backgroundColor: alpha(theme.palette.error.main, 0.08),
			"& .delete-icon": { color: "error.dark" },
		},
	},
	boxCenter: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	chipTags: {
		borderWidth: "1px",
		borderStyle: "solid",
		fontWeight: "bold",
		height: "20px",
		fontSize: "0.75rem",
		"& .MuiChip-label": { px: 1 },
	},
	boxChips: {
		display: "flex",
		alignItems: "center",
		gap: 0.5,
		flexWrap: "wrap",
		mt: 0.5,
	},
	labelTag: {
		position: "absolute",
		top: 0,
		left: 0,

		color: "#fff",
		px: 1.5,
		py: 0.3,
		fontSize: "0.7rem",
		fontWeight: "bold",
		borderBottomRightRadius: "16px",
		zIndex: 2,
		textTransform: "uppercase",
	},
	boxContent: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "stretch",
	},
});

export default styles;
